/**
 * @generated SignedSource<<bb6f71c5f2f43228ce8387d5b5165329>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeaturedEventsScrollerEventConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"EventCardWrapper">;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "FeaturedEventsScrollerEventConnection";
};
export type FeaturedEventsScrollerEventConnection$key = {
  readonly " $data"?: FeaturedEventsScrollerEventConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"FeaturedEventsScrollerEventConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FeaturedEventsScrollerEventConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EventCardWrapper"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EventConnection",
  "abstractKey": null
};

(node as any).hash = "3fd1a5351f729110919c000a1c5aa95c";

export default node;
